function customProductMediaSliderInit() {
  document.querySelectorAll(".product-media-carousel").forEach(initProductMediaCarousel);
}

function initProductMediaCarousel(sliderEl) {
  if (!sliderEl) return;

  if (sliderEl.swiper) {
    sliderEl.swiper.destroy(true, true);
  }

  const selectedMediaId = sliderEl.getAttribute("data-selected-media-id");
  const initialSlide = getSlideIndexForMedia(sliderEl, selectedMediaId);

  new Swiper(sliderEl, {
    slidesPerView: 1,
    loop: true,
    initialSlide: initialSlide > -1 ? initialSlide : 0,
    navigation: {
      nextEl: sliderEl.querySelector(".swiper-button-next"),
      prevEl: sliderEl.querySelector(".swiper-button-prev"),
    },
    keyboard: {
      enabled: true,
    },
  });
}

function getSlideIndexForMedia(sliderEl, mediaId) {
  if (!sliderEl || mediaId == null || mediaId === "") return -1;
  const slides = sliderEl.querySelectorAll(
    ".swiper-wrapper > .swiper-slide:not(.swiper-slide-duplicate)"
  );
  return Array.from(slides).findIndex(
    (slide) => slide.getAttribute("data-media-id") === String(mediaId)
  );
}

document.addEventListener("variant:update", (event) => {
  const mediaId =
    event.detail && event.detail.resource && event.detail.resource.featured_media
      ? event.detail.resource.featured_media.id
      : null;
  if (mediaId == null) return;

  const scope =
    (event.target instanceof Element &&
      event.target.closest("quick-add-dialog, dialog, .shopify-section")) ||
    document;

  scope.querySelectorAll(".product-media-carousel").forEach((sliderEl) => {
    sliderEl.setAttribute("data-selected-media-id", String(mediaId));
    initProductMediaCarousel(sliderEl);
  });
});

customProductMediaSliderInit();
